import { Link } from "react-router-dom";
import "./PropertyCard.css";
export default function PropertyCard({ property }) {
  var url = "/stays/" + property.slug;
  return (
    <Link to={url} className="prop-card">
      <div className="prop-img-wrap">
        <div className="prop-bg" style={{backgroundImage:"url("+property.heroImage+")"}} />
        <div className="prop-grad" />
        {property.featured && <span className="prop-tag">Featured</span>}
        <div className="prop-info-overlay">
          <span className="prop-type-tag">{property.type}</span>
          <h3 className="prop-name-overlay">{property.name}</h3>
          <p className="prop-loc-overlay">{property.location}</p>
          <div className="prop-explore">Explore Stays <span>&#8594;</span></div>
        </div>
      </div>
      <div className="prop-body">
        <p className="prop-tagline">{property.tagline}</p>
        <div className="prop-footer">
          <span className="prop-rating">&#9733; {property.rating} ({property.reviewCount})</span>
          <span className="prop-price">from {property.priceFrom} EUR/night</span>
        </div>
      </div>
    </Link>
  );
}
